
export default {
  isCookieStatisticsAccepted() {
    let enableCookie = this.isCookieAccepted()
    if (enableCookie) {
      let contentCookie = this.getCookieContent()
      if (contentCookie !== false) {
        if (contentCookie.statistics) {
          return true
        }
      }
    }
    return false
  },
  isCookieAccepted() {
    let accepted = localStorage.getItem('cookies:accepted')
    return (accepted == 'true')
  },
  setCookieAccepted(val) {
    localStorage.setItem('cookies:accepted', val)
  },
  setCookieContent(obj) {
    localStorage.setItem('cookies:content', JSON.stringify(obj))
  },
  getCookieContent() {
    let data = localStorage.getItem('cookies:content')
    if (data == null) {
      return false
    }
    return JSON.parse(data)
  },
  setScope(obj) {
    localStorage.setItem('product:scope', JSON.stringify(obj))
  },
  getScope() {
    let data = localStorage.getItem('product:scope')
    if (data == null) {
      return false
    }
    return JSON.parse(data)
  },
  deleteScope() {
    localStorage.removeItem('product:scope')
  }
};





